import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { RolePermissionService } from '~app/services/role-permission.service';

@Injectable({
  providedIn: 'root',
})
export class IsAdminGuard  {
  constructor(
    private rolePermissionService: RolePermissionService,
    private router: Router
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | boolean {
    return this.rolePermissionService.isAdmin$.pipe(
      take(1),
      map((isAdmin) => isAdmin || this.router.parseUrl('/home'))
    );
  }
}
